import React from 'react';
import PropTypes from 'prop-types';

import DataCacheService from '@/shared/services/DataCacheService';

const resolveFormattingCulture = () => {
  const culture = DataCacheService.getDataCache()?.employee?.userCulture;
  switch (culture?.toLowerCase()) {
    case 'nl':
    case 'nl-be':
    case 'en-be':
      return 'nl-BE';
    case 'nl-nl':
    case 'en-nl':
      return 'nl-NL';
    case 'fr':
    case 'fr-be':
      return 'fr-BE';
    default:
      break;
  }
  switch (DataCacheService.getTenantConfiguration()) {
    case 3:
      return 'fr-BE';
    case 5:
      return 'nl-NL';
    default:
      return 'nl-BE';
  }
};

const formatterCache = new Map();
const getFormatter = (culture, currency, minimumFractionDigits, maximumFractionDigits) => {
  const key = `${culture}|${currency}|${minimumFractionDigits}|${maximumFractionDigits}`;
  let formatter = formatterCache.get(key);
  if (!formatter) {
    formatter = new Intl.NumberFormat(culture, {
      style: 'currency',
      currency,
      currencyDisplay: 'symbol',
      minimumFractionDigits,
      maximumFractionDigits,
    });
    formatterCache.set(key, formatter);
  }
  return formatter;
};

const FormattedCurrency = ({
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
  value,
  className = '',
}) => {
  const currency = DataCacheService.getDefaultCompany()?.currencyCode || 'EUR';
  const formatted = getFormatter(
    resolveFormattingCulture(),
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  ).format(value);

  return <span className={className}>{formatted}</span>;
};

FormattedCurrency.propTypes = {
  value: PropTypes.number.isRequired,
  minimumFractionDigits: PropTypes.number,
  maximumFractionDigits: PropTypes.number,
  className: PropTypes.string,
};

export default FormattedCurrency;
